import { useEffect } from "react";
import { batch, useSignal } from "@preact/signals-react";
import { postSubmit, isEmpty } from "@ui-seeker/utils";
import { useAppToast } from "@ui-seeker/app";

import { WEBBACK_V2_API } from "@constants";
import {isLoadingCommonFilters, commonFiltersValue, isSystemBusy} from "@signals";
import { elementsInLoading, resetMarketplacesLostBuyBoxOverviewSignal } from "../signals";


export default function useLostBuyBoxOverviewTableCompetitorsData() {

	const { showToast } = useAppToast()

	const isLoadingCompetitorsTable = useSignal(false)
	const competitorsTableData = useSignal([])

	useEffect(() => {
		if (isLoadingCommonFilters.value) batch(() => {
			isLoadingCompetitorsTable.value = true
			resetMarketplacesLostBuyBoxOverviewSignal()
			postSubmit(`${WEBBACK_V2_API}/marketplaces/lose-buy-box-overview/competitors-table`, commonFiltersValue.value).then((res) => {
				competitorsTableData.value = res
                isLoadingCompetitorsTable.value = false
			}).catch(() => {
                isSystemBusy.value = true
                isLoadingCompetitorsTable.value = false
				isLoadingCommonFilters.value = false
            })
		})
	}, [isLoadingCommonFilters.value]);


	useEffect(() => {
		if (isLoadingCompetitorsTable.value)
			elementsInLoading.value = [...elementsInLoading.value, 'tableCompetitors']
		else
			elementsInLoading.value = elementsInLoading.value.filter(item => item !== 'tableCompetitors')
	}, [isLoadingCompetitorsTable.value])

	return {
		competitorsTableData: competitorsTableData.value,
        isLoadingCompetitorsTable: isLoadingCompetitorsTable.value
	}
}